import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import IndexTopBar from '../layout/IndexTopBar';

export default function Index() {
    const navigate = useNavigate();
    const { currentUser, tutorialCompleted } = useAuth();
    useEffect(() => {
        if (currentUser && tutorialCompleted === false) {
            navigate('/tutorial');
        }

    }, [currentUser, tutorialCompleted, navigate]);
    return (
        <div>
            {/* Include the Top Bar */}
            <IndexTopBar />
        </div>
    );
}
